<template>
  <card>
    <template slot="header">
      <h4 class="card-title pb-5p">{{ rfmTracking.messageId }} - {{ rfmTracking.messageDescription }}</h4>
    </template>
    <bar-chart
      :height="140"
      :labels="rfmTracking.labels"
      :datasets="rfmTracking.datasets"
      :extraOptions="options"
    ></bar-chart>
  </card>
</template>
<script>
import { StatsCard, ChartCard } from "@/components/dashboard/index";
import BarChart from "@/components/dashboard/BarChart";
import AlertsDashboardTemplate from "@/components/AlertsDashboardTemplate.vue";
export default {
  name: "rfmTrackingMessagesSection",
  props: {
    rfmTracking: Object,
  },
  components: {
    BarChart,
    AlertsDashboardTemplate,
  },
  methods: {},
  data() {
    return {
      options: {
        scales: {
          yAxes: [
            {
              stacked: true,
            },
          ],
          xAxes: [
            {
              stacked: true,
              categoryPercentage: 0.5,
              barPercentage: 1,
              
            },
          ],
        },
      },
    };
  },
};
</script>
<style scoped>
.align-end {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: flex-end;
  align-items: center;
  align-content: center;
}
.pb-5p {
  padding-bottom: 5px;
}
</style>
